(function () {
  // Designbaer: manche FIF-Produkte benennen die Druckfarben-Option auf Deutsch
  // ("Aufdruckfarbe": "Schwarz"/"Weiß"), die Bild-Alt-Texte sind aber durchgehend
  // auf Englisch ("white print"/"black print"). Diese Tabelle uebersetzt bekannte
  // Druckfarben-Woerter in beide Richtungen auf einen gemeinsamen Nenner.
  var PRINT_SYNONYMS = {
    black: ['black', 'schwarz'],
    white: ['white', 'weiß', 'weiss']
  };
  function canonicalPrint(raw) {
    if (!raw) return null;
    var lower = String(raw).toLowerCase();
    var found = null;
    Object.keys(PRINT_SYNONYMS).forEach(function (canon) {
      if (PRINT_SYNONYMS[canon].indexOf(lower) > -1) found = canon;
    });
    return found;
  }
  function setup(info) {
    if (info.dataset.mediaFilterInit) return;
    info.dataset.mediaFilterInit = '1';
    var wrapper = info.querySelector('.product') || info;
    var configEl = info.querySelector('[data-media-filter-config]');
    if (!configEl) return;
    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }
    var colorValues = (config.colorValues || []).map(function (v) { return String(v).toLowerCase(); }).filter(Boolean);
    var mediaAlt = {};
    Object.keys(config.mediaAlt || {}).forEach(function (k) {
      mediaAlt[k] = (config.mediaAlt[k] || '').toLowerCase();
    });
    function getMid(el) {
      var raw = el.getAttribute('data-media-id') || el.getAttribute('data-target') || '';
      return raw.split('-').pop();
    }
    // Designbaer: findet, an welcher Stelle im (kleingeschriebenen) Alt-Text die
    // Textilfarbe steht (z.B. "dusty pink" oder "mineral blue"). Alles davor/danach
    // wird fuer die Farb- bzw. Druckfarben-Filterung getrennt betrachtet -- robuster
    // als eine feste Suche nach "front"/"back", da nicht alle Produkte diese Woerter
    // im Alt-Text verwenden (z.B. Beanie: "... Dusty Pink FIF design white print").
    function findColorMatch(altLower) {
      var best = null;
      colorValues.forEach(function (c) {
        var i = altLower.indexOf(c);
        if (i > -1 && (!best || i < best.index)) best = { value: c, index: i, length: c.length };
      });
      return best;
    }
    // Designbaer-Fix (06.08.2026): Galerie zeigt fuer die gewaehlte Textilfarbe UND die
    // gewaehlte Druckfarbe nur noch genau die passenden Fotos. Funktioniert unabhaengig
    // davon, ob das Produkt "Print Colour"/"Black"/"White" (z.B. Hoodie) oder
    // "Aufdruckfarbe"/"Schwarz"/"Weiß" (z.B. Beanie, Women's Hoodie) verwendet, und
    // unabhaengig davon, ob "front"/"back" im Alt-Text vorkommt. Bei Textilfarben ohne
    // Druckfarben-Unterscheidung (z.B. Black/White beim Hoodie) wird nicht zusaetzlich
    // nach Druckfarbe gefiltert, da es dafuer ohnehin nur ein Bildpaar gibt.
    function apply() {
      var idInput = info.querySelector('input[name=id]');
      var variantId = idInput ? parseInt(idInput.value) : null;
      var variant = config.variants.find(function (v) { return v.id === variantId; }) || config.variants[0];
      if (!variant) return;
      var selectedColor = variant.color ? String(variant.color).toLowerCase() : '';
      var selectedPrint = canonicalPrint(variant.printColour);
      var els = info.querySelectorAll('[data-media-id], [data-target]');
      els.forEach(function (el) {
        var midStr = getMid(el);
        var li = el.tagName === 'LI' ? el : el.closest('li');
        if (!li) return;
        var hide = false;
        var altFull = mediaAlt[midStr] || '';
        var colorMatch = findColorMatch(altFull);
        if (selectedColor && colorMatch) {
          hide = colorMatch.value !== selectedColor;
        }
        if (!hide && selectedPrint) {
          var tail = colorMatch ? altFull.slice(colorMatch.index + colorMatch.length) : altFull;
          var mentionsAnyPrint = Object.keys(PRINT_SYNONYMS).some(function (canon) {
            return PRINT_SYNONYMS[canon].some(function (w) { return tail.indexOf(w) > -1; });
          });
          if (mentionsAnyPrint) {
            var matchesSelected = PRINT_SYNONYMS[selectedPrint].some(function (w) { return tail.indexOf(w) > -1; });
            if (!matchesSelected) hide = true;
          }
        }
        li.style.setProperty('display', hide ? 'none' : '', 'important');
      });
    }
    // Designbaer-Fix (06.08.2026): Manche Textilfarben (z.B. "Black", "White") gibt es
    // nur mit EINER Druckfarbe (weil z.B. schwarzer Druck auf schwarzem Stoff unsichtbar
    // waere). Wechselt man von einer Farbe mit zwei Druckfarben zu so einer Farbe, bleibt
    // die zuvor gewaehlte Druckfarbe stehen, obwohl es diese Kombination gar nicht gibt.
    // Shopify markiert diese Kombination dann als "nicht verfuegbar" -- die interne
    // Kennung (verstecktes Eingabefeld "id") wird dabei zuverlaessig geleert, auch wenn
    // ein unabhaengiger, separater Theme-Fehler (window.variantStrings fehlt) verhindert,
    // dass Shopify selbst Preis/Kaufen-Button zuverlaessig ausblendet. Dieser Fix prueft
    // daher direkt das "id"-Feld statt sich auf die (fehlerhafte) Shopify-eigene
    // Sichtbarkeitslogik zu verlassen, und waehlt automatisch die einzige verfuegbare
    // Druckfarbe fuer die aktuell gewaehlte Textilfarbe aus.
    function findUnavailableSelect() {
      var selects = wrapper.querySelectorAll('select');
      for (var i = 0; i < selects.length; i++) {
        var sel = selects[i];
        var opt = sel.options[sel.selectedIndex];
        if (opt && /nicht verfügbar/i.test(opt.text)) {
          return sel;
        }
      }
      return null;
    }
    function isUnavailableState() {
      var idInput = wrapper.querySelector('input[name="id"]');
      return !!idInput && idInput.value === '';
    }
    function autoCorrectUnavailableCombo() {
      if (!isUnavailableState()) return;
      var sel = findUnavailableSelect();
      if (!sel) return;
      var validOption = Array.prototype.find.call(sel.options, function (o) {
        return !/nicht verfügbar/i.test(o.text);
      });
      if (!validOption || validOption.value === sel.value) return;
      sel.value = validOption.value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
    apply();
    var idInputEl = wrapper.querySelector('input[name="id"]');
    if (idInputEl) {
      idInputEl.addEventListener('change', function () {
        setTimeout(autoCorrectUnavailableCombo, 50);
      });
    }
    info.addEventListener('change', function () {
      apply();
      setTimeout(apply, 300);
      setTimeout(autoCorrectUnavailableCombo, 500);
      setTimeout(apply, 900);
      setTimeout(autoCorrectUnavailableCombo, 1200);
      setTimeout(autoCorrectUnavailableCombo, 2000);
      setTimeout(autoCorrectUnavailableCombo, 3000);
    });
  }
  function init() {
    document.querySelectorAll('product-info').forEach(setup);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('product-info:loaded', function (e) {
    setup(e.target);
  });
})();
